import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { API_URL } from '@/lib/config';

const DataRequestInput = ({ userId, visibleProjects }) => {
  const [inputValue, setValue] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccess('');

    if (!inputValue.trim() || isSubmitting) return;

    try {
      // Save the request to the database
      const response = await fetch(`${API_URL}/api/data-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId,
          requestContent: inputValue.trim(),
          visibleProjects: visibleProjects || []
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to save data request');
      }

      // Track the submission in Mixpanel with sticky parameters
      mixpanel.track('Data request submitted', {
        'Request content': inputValue,
        userId: userId,
        'Visible projects': visibleProjects
      });

      setIsSubmitted(true);
      setSuccess('Data request submitted successfully!');

      // Reset after 5 seconds
      setTimeout(() => {
        setIsSubmitted(false);
        setValue('');
      }, 5000);
    } catch (err) {
      console.error('Error submitting data request:', err);
      setError('Failed to submit data request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFocus = () => {
    // Track when input is focused
    mixpanel.track('Data request input focused', {
      userId: userId,
      visibleProjects: visibleProjects
    });
  };

  return (
    <div className="w-full p-4 rounded flex flex-col justify-start items-start gap-6">
      {!isSubmitted ? (
        <div className="w-full px-6 py-4 bg-[#EDF0F5] rounded-[100px]">
          <form onSubmit={handleSubmit} className="w-full">
            <div className="w-full px-6 py-4 bg-white shadow-sm rounded-[30px] border border-[#D4DAE2] flex flex-wrap sm:flex-nowrap items-center gap-2">
              <input
                type="text"
                value={inputValue}
                onChange={(e) => setValue(e.target.value)}
                onFocus={handleFocus}
                placeholder="Can't find the data you need? Ask for it here"
                className="w-full sm:flex-1 text-base text-[#717E9B] font-normal leading-[22px] tracking-[0.15px] focus:outline-none min-w-0"
              />
              {inputValue.trim() && (
                <button
                  type="submit"
                  className="w-full sm:w-auto mt-2 sm:mt-0 h-8 bg-[#4DA1D6] rounded-[100px] px-4 py-1 flex justify-center items-center"
                >
                  <span className="text-white text-lg font-semibold leading-[26px] capitalize">
                    Submit
                  </span>
                </button>
              )}
            </div>
          </form>
        </div>
      ) : (
        <div className="w-full px-6 py-4 bg-[#EDF0F5] rounded-[100px]">
          <div className="px-6 py-4 bg-[#EDF0F5] shadow-sm rounded-[30px] border border-[#D4DAE2] flex justify-start items-center gap-2">
            <div className="text-center text-[#2E364B] text-base font-semibold leading-[22px] tracking-[0.15px]">
              {success}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataRequestInput;